import { summarizeDecimalRange } from '../summarizeDecimalRange';
const hasBound = (range)=>range.gte != null || range.lte != null || range.gt != null || range.lt != null;
export const decimalValueLabel = (range)=>summarizeDecimalRange(range);
export const decimalIsEditable = (range)=>!hasBound(range);
export const decimalEditableValue = (range)=>{
    var _ref, _range_eq;
    return (_ref = (_range_eq = range.eq) !== null && _range_eq !== void 0 ? _range_eq : range.neq) !== null && _ref !== void 0 ? _ref : '';
};
export const parseDecimal = (value)=>{
    const trimmed = value.trim();
    return trimmed !== '' && !Number.isNaN(Number(trimmed));
};
export const decimalFromInput = (value, isExclude)=>{
    const trimmed = value.trim();
    if (trimmed === '') return undefined;
    return isExclude ? {
        neq: trimmed
    } : {
        eq: trimmed
    };
};
export const decimalOperator = (range, onChange, texts)=>{
    if (range.neq == null) return undefined;
    return {
        label: texts.isNot,
        onToggle: ()=>onChange({
                eq: range.neq
            }),
        biName: 'drafts_ai_search_chip_toggle_service_decimal_operator'
    };
};
